module.exports = __webpack_public_path__ + "assets/ef60a4f6c25ef7f39f2d25a748dbecfe.woff";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/semantic/themes/default/assets/fonts/outline-icons.woff
// module id = 3656
// module chunks = 0